export default __webpack_public_path__ + "static/media/screen1.79362684.png";